import { ThemeProvider as KhThemeProvider, getThemeInlineScript } from "@barrykilby/ui/lib/theme";

export { useTheme } from "@barrykilby/ui/lib/theme";
export type { Theme, ThemePreference, ThemeContextValue } from "@barrykilby/ui/lib/theme";

export const themeInlineScript = getThemeInlineScript("manos_theme");

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <KhThemeProvider storageKey="manos_theme">{children}</KhThemeProvider>;
}
